import BassinBlock from "../components/blocks/BassinBlock";

const BassinOverview = () => {

    return (<>
    <BassinBlock/>
    </>)
}
export default BassinOverview